import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetRecievableDetailsQuery } from "../../../services/Reports";
import {
  getReceivableDetailsRequest,
  getReceivableDetailsFailure,
  getReceivableDetailsSuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  // State
  const state = useAppSelector((state) => state.reports);

  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allReceivableDetails,
    isLoading: receivableDetailsLoading,
    isError: receivableDetailsError,
  } = useGetRecievableDetailsQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.receivableDetailsPageNo,
    pageSize: state.receivableDetailsPageSize,
    fromDate: new Date(state.receivableDetailsFromDate).toLocaleDateString(),
    toDate: new Date(state.receivableDetailsToDate).toLocaleDateString(),
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (receivableDetailsLoading) {
      dispatch(getReceivableDetailsRequest());
    }
    if (receivableDetailsError) {
      dispatch(getReceivableDetailsFailure(receivableDetailsError));
    }
    if (allReceivableDetails) {
      dispatch(
        getReceivableDetailsSuccess({
          data: allReceivableDetails.data.recieveableDetails[0].data || [],
          totalPages:
            allReceivableDetails.data.recieveableDetails[0].metadata[0]
              ?.total || 0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allReceivableDetails,
    profileData,
    state.receivableDetailsFromDate,
    state.receivableDetailsToDate,
    state.receivableDetailsPageNo,
    state.receivableDetailsPageSize,
  ]);
  return <></>;
};
export default Content;
